import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: String, i18nCopied: { type: String, default: "Copied!" } };

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.element.innerHTML;
      this.element.textContent = this.i18nCopiedValue;
      this.element.classList.add("is-copied");
      setTimeout(() => {
        this.element.innerHTML = original;
        this.element.classList.remove("is-copied");
      }, 1800);
    });
  }
}
